export default __webpack_public_path__ + "static/hero_nosotros-77f91405e07a9fa4475fe0aba3a643fd.jpg";